import React, { useState } from "react";
import { Container, Row, Col, Button, Accordion, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IoArrowForwardOutline } from "react-icons/io5";
import { Helmet } from "react-helmet-async";

import { FiPlus, FiMinus } from "react-icons/fi";
// import {
//   FaUserGraduate,
//   FaExchangeAlt,
//   FaBriefcase,
//   FaLaptopCode,
//   FaCheckSquare,
// } from "react-icons/fa";

import CourseBannerImage from "../../assets/publicpageimg/internship-programme-image.png";

import finalYear from "../../assets/publicpageimg/final-year-students.svg";
import careerSwitch from "../../assets/publicpageimg/career-switchers.svg";
import jobSeekers from "../../assets/publicpageimg/job-seekers.svg";
import selfLearners from "../../assets/publicpageimg/self-learners.svg";


import yourInternshipLearn from "../../assets/publicpageimg/your-internship-learn.svg";
import yourInternshipApply from "../../assets/publicpageimg/your-internship-apply.svg";
import yourInternshipExperience from "../../assets/publicpageimg/your-internship-experience.svg";
import yourInternshipGrow from "../../assets/publicpageimg/your-internship-grow.svg";

import HomeBanner from "../../assets/publicpageimg/ready-start-your-internship-journey.png";

import "./Internshipprogramme.css";

const faqsData = [
  {
    question:
      "What makes Skilledition's internship different from other internships?",
    answer:
      "Skilledition internships are provided by our parent company, Digisphere Tech Pvt. Ltd., offering real-world projects, practical learning, and hands-on experience to help students build industry-ready skills.",
  },
  {
    question: "Who is eligible for the internship programme?",
    answer:
      "Our internship is open to college students, fresh graduates, career switchers, and anyone looking to gain practical skills and real-world experience.",
  },
  {
    question: "Do I need prior experience to join?",
    answer:
      "No. The program is beginner-friendly and designed to help learners build skills step by step, regardless of their prior experience.",
  },
  {
    question: "How will this internship help my career?",
    answer:
      "You'll develop practical skills, gain real-world experience, build professional confidence, and prepare yourself for future career opportunities.",
  },
  {
    question: "Will I receive an internship certificate?",
    answer:
      "Yes, students who successfully complete the internship programme will receive an official Internship Completion Certificate from Skilledition, powered by Digisphere.",
  },
];

const careerCard = [
  {
    image: yourInternshipLearn,
    text: "Learn",
    subtitle:
      "Build strong foundations with industry-relevant concepts and skills.",
  },
  {
    image: yourInternshipApply,
    text: "Apply",
    subtitle:
      "Put your learning into action through hands-on projects and real tasks.",
  },
  {
    image: yourInternshipExperience,
    text: "Experience",
    subtitle:
      "Gain practical exposure by working on real-world development challenges",
  },
  {
    image: yourInternshipGrow,
    text: "Grow",
    subtitle:
      "Enhance your skills, build confidence, and accelerate your career journey.",
  },
];

const Internshipprogramme = () => {
  const [activeKey, setActiveKey] = useState("0");
  const navigate = useNavigate();

  const openWhatsApp = () => {
    const phoneNumber = "918143879627";
    const message =
      "Thanks for your interest in our Internship Program. Please share your name, qualification, and course. We'll guide you through the process.";
    window.open(
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`,
      "_blank",
    );
  };

  return (
    <>
      <Helmet>
        <title>
          Skilledition | Internships – Real-World Experience for Students
        </title>

        <meta
          name="description"
          content="Join Skilledition internships to gain hands-on experience, industry exposure, and real-world project skills that boost your career readiness."
        />

        <link rel="canonical" href="https://skilledition.in/internship" />

        {/* Open Graph / Social Share */}
        <meta
          property="og:title"
          content="Skilledition | Internships – Real-World Experience for Students"
        />
        <meta
          property="og:description"
          content="Hands-on internships designed to build practical skills and industry confidence."
        />
        <meta property="og:url" content="https://skilledition.in/internship" />
        <meta
          property="og:image"
          content="https://skilledition.in/seo-banner-internship.png"
        />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Skilledition | Internships – Real-World Experience for Students"
        />
        <meta
          name="twitter:description"
          content="Hands-on internships designed to build practical skills and industry confidence."
        />
        <meta
          name="twitter:image"
          content="https://skilledition.in/seo-banner-internship.png"
        />
      </Helmet>

      <section className="skilledition-builds-section reveal">
        <Container className="skilledition-builds-section-container">
          <Row className="skilledition-builds-section-row align-items-center">
            {/* LEFT CONTENT */}
            <Col lg={6} className="skilledition-builds-section-left">
              <h1 className="skilledition-builds-section-title">
                Skills First. <br />
                Internship Next. <br />
                Career Always.
              </h1>

              <p className="skilledition-builds-section-description">
                A complete pathway to career growth learn in‑demand skills
                through structured training, real‑world projects, and internship
                experience that build confidence and practical knowledge.
              </p>

              <div className="skilledition-builds-section-buttons">
                <Button
                  className="skilledition-banner-section-btn"
                  onClick={() => navigate("/contact")}
                >
                  Take the First Step <IoArrowForwardOutline />
                </Button>
                <Button
                  className="skilledition-intern-track-btns"
                  // onClick={() => navigate("/contact")}
                  onClick={() => {
                    document
                      .getElementById("Internship-section")
                      .scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  Explore Internship Tracks
                </Button>
              </div>
            </Col>

            {/* RIGHT IMAGE */}
            <Col lg={6} className="skilledition-builds-section-right">
              <img
                src={CourseBannerImage}
                alt="MERN Course Banner"
                className="skilledition-builds-section-image"
              />
            </Col>
          </Row>
        </Container>
      </section>

      <section
        className="skilledition-internship-portfolio-section reveal"
        id="Internship-section"
      >
        <Container>
          {/* HEADER */}
          <div className="skilledition-internship-portfolio-header text-center">
            <h2 className="skilledition-internship-portfolio-title">
              From Learning to Internships
            </h2>
            <p className="skilledition-internship-portfolio-subtitle">
              Turn your knowledge into real-world experience through hands-on
              projects that help you build practical skills and prepare for your
              career.
            </p>
          </div>

          {/* CARDS */}
          <Row className="skilledition-internship-program-portfolio-cards">
            <Col lg={6} md={12}>
              <Card className="skilledition-internship-program-portfolio-card">
                <h5 className="skilledition-internship-program-portfolio-card-title">
                  Mock Interviews & Skill Reviews
                </h5>
                {/* <p className="skilledition-internship-portfolio-card-text">
                  Practice interviews designed to evaluate your skills, explain
                  projects, and handle common internship interview questions.
                </p> */}
                <ul className="skilledition-internship-program-portfolio-list">
                  <li>Project walkthrough discussions</li>
                  <li>Skill Gap Feedback </li>
                  <li>Soft Skills Practice & Interview Prep</li>
                </ul>
              </Card>
            </Col>

            <Col lg={6} md={12}>
              <Card className="skilledition-internship-program-portfolio-card">
                <h5 className="skilledition-internship-program-portfolio-card-title">
                  Project-Based Learning
                </h5>
                {/* <p className="skilledition-internship-portfolio-card-text">
                  Build portfolios that go beyond screenshots. We help you
                  showcase real projects, clear explanations, and practical
                  outcomes — so your work speaks for itself.
                </p> */}
                <ul className="skilledition-internship-program-portfolio-list">
                  <li>Work on guided, real-world projects</li>
                  <li>Turn knowledge into practical experience</li>
                  <li>Build job-ready skills through hands-on practice</li>
                </ul>
              </Card>
            </Col>
          </Row>

          {/* Bottom Card */}
          <Row className="justify-content-center mt-4">
            <Col lg={6} md={12}>
              <Card className="skilledition-internship-program-portfolio-card">
                <h5 className="skilledition-internship-program-portfolio-card-title">
                  Career Preparation
                </h5>

                <ul className="skilledition-internship-program-portfolio-support-list">
                  <li>Develop the skills employers value</li>
                  <li>Build confidence for interviews and the workplace</li>
                  <li>
                    Take the next step with confidence and practical skills
                  </li>
                </ul>
              </Card>
            </Col>
          </Row>

          {/* BOTTOM SUPPORT BOX */}
          {/* <div className="skilledition-internship-program-portfolio-support">
            <h6 className="skilledition-internship-program-portfolio-support-title">
              Career Preparation
            </h6> */}
          {/* <p className="skilledition-internship-portfolio-support-text">
              We guide you to:
            </p> */}
          {/* <ul className="skilledition-internship-program-portfolio-support-list">
              <li>Develop the skills employers value</li>
              <li>Build confidence for interviews and the workplace</li>
              <li>Take the next step with confidence and practical skills</li>
            </ul> */}

          {/* <h5 className="skilledition-internship-portfolio-focus-title">
              Focus Areas:
            </h5>
            <div className="skilledition-internship-portfolio-focus">
              <span className="skilledition-internship-portfolio-focus-item">
                <strong>Profile readiness :</strong> <FaCheckSquare /> High
              </span>
              <span className="skilledition-internship-portfolio-focus-item">
                <strong>Resume clarity :</strong> <FaCheckSquare /> Improved
              </span>
              <span className="skilledition-internship-portfolio-focus-item">
                <strong>Internship confidence :</strong> <FaCheckSquare />{" "}
                Strong
              </span>
            </div> */}
          {/* </div> */}
        </Container>
      </section>

      <section className="skilledition-internshipwhos-section reveal">
        <Container className="skilledition-internshipwhos-container">
          <Row className="justify-content-center">
            <Col lg={8} md={10} className="text-center">
              <h2 className="skilledition-internship-portfolio-title">
                Who is this for?
              </h2>
              <p className="skilledition-internship-portfolio-subtitle mb-5">
                Designed for learners who want more than just online tutorials
                develop practical skills, real-world experience, and the
                confidence to succeed.
              </p>
            </Col>
          </Row>

          <Row className="skilledition-internship-program-who-items-row justify-content-center">
            <Col lg={3} md={6} sm={12} className="mb-4">
              <Card className="skilledition-internship-program-who-card">
                <div className="skilledition-internship-program-who-icon">
                  <img
                    src={finalYear}
                    alt="final year"
                    className="skilledition-internship-program-who-img"
                  />
                </div>
                <Card.Body className="p-0">
                  <Card.Title className="skilledition-internship-program-who-title">
                    Students
                  </Card.Title>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={3} md={6} sm={12} className="mb-4">
              <Card className="skilledition-internship-program-who-card">
                <div className="skilledition-internship-program-who-icon">
                  <img
                    src={careerSwitch}
                    alt="career switchers"
                    className="skilledition-internship-program-who-img"
                  />
                </div>
                <Card.Body className="p-0">
                  <Card.Title className="skilledition-internship-program-who-title">
                    Career Switchers
                  </Card.Title>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={3} md={6} sm={12} className="mb-4">
              <Card className="skilledition-internship-program-who-card">
                <div className="skilledition-internship-program-who-icon">
                  <img
                    src={jobSeekers}
                    alt="job seekers"
                    className="skilledition-internship-program-who-img"
                  />
                </div>
                <Card.Body className="p-0">
                  <Card.Title className="skilledition-internship-program-who-title">
                    Job Seekers
                  </Card.Title>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={3} md={6} sm={12} className="mb-4">
              <Card className="skilledition-internship-program-who-card">
                <div className="skilledition-internship-program-who-icon">
                  <img
                    src={selfLearners}
                    alt="career switchers"
                    className="skilledition-internship-program-who-img"
                  />
                </div>
                <Card.Body className="p-0">
                  <Card.Title className="skilledition-internship-program-who-title">
                    Self-Learners
                  </Card.Title>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="skilledition-internshipcareer-section reveal">
        <Container className="skilledition-internshipcareer-container">
          <Row className="justify-content-center">
            <Col lg={8} md={10} className="text-center">
              <h2 className="skilledition-internshipcareer-title">
                Your Internship Journey
              </h2>
              <p className="skilledition-internshipcareer-subtitle">
                Progress through every stage of learning from building core
                skills to gaining practical experience in a structured,
                career-focused environment.
              </p>
            </Col>
          </Row>

          <Row className="skilledition-internshipcareer-program-cards-row">
            {careerCard.map((item, index) => (
              <Col
                lg={3}
                md={6}
                sm={12}
                className="mb-4 position-relative"
                key={index}
              >
                <Card className="skilledition-internshipcareer-program-card">
                  <div className="skilledition-internshipcareer-program-card-image">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="skilledition-internshipcareer-program-card-icon-img"
                    />
                  </div>

                  <Card.Body className="p-0">
                    <Card.Text className="skilledition-internshipcareer-card-title">
                      {item.text}
                    </Card.Text>

                    <Card.Text className="skilledition-internshipcareer-card-subtitle">
                      {item.subtitle}
                    </Card.Text>
                  </Card.Body>
                </Card>

                {index !== careerCard.length - 1 && (
                  <div className="skilledition-internshipcareer-pro-card-journey-connector">
                    <span>→</span>
                  </div>
                )}
              </Col>
            ))}

            {/* <Col lg={3} md={6} sm={12}>
              <Card className="skilledition-internshipcareer-card">
                <h5 className="skilledition-internshipcareer-card-title">
                  Eligibility
                </h5>
              </Card>
            </Col> */}

            {/* <Col lg={3} md={6} sm={12}>
              <Card className="skilledition-internshipcareer-card">
                <h5 className="skilledition-internshipcareer-card-title">
                  Optimization
                </h5>
              </Card>
            </Col>

            <Col lg={3} md={6} sm={12}>
              <Card className="skilledition-internshipcareer-card">
                <h5 className="skilledition-internshipcareer-card-title">
                  Mock Drills
                </h5>
              </Card>
            </Col>

            <Col lg={3} md={6} sm={12}>
              <Card className="skilledition-internshipcareer-card">
                <h5 className="skilledition-internshipcareer-card-title">
                  Opportunities
                </h5>
              </Card>
            </Col> */}
          </Row>
        </Container>
      </section>

      <section className="skilledition-faqs-section reveal">
        <Container>
          <Row>
            {/* LEFT CONTENT */}
            <Col lg={5} className="skilledition-faqs-left">
              <h2 className="skilledition-faqs-title">
                Frequently asked <br /> questions.
              </h2>

              <p className="skilledition-faqs-desc">
                Skilledition is designed to answer common questions clearly and
                help learners understand our platform easily.
              </p>
            </Col>

            {/* RIGHT FAQ */}
            <Col lg={7} className="skilledition-faqs-right">
              <Accordion
                activeKey={activeKey}
                className="skilledition-faqs-accordion"
              >
                {faqsData.map((faq, index) => (
                  <Accordion.Item
                    eventKey={index.toString()}
                    key={index}
                    className={`skilledition-faq-item ${
                      activeKey === index.toString() ? "active" : ""
                    }`}
                  >
                    <Accordion.Header
                      onClick={() =>
                        setActiveKey(
                          activeKey === index.toString()
                            ? null
                            : index.toString(),
                        )
                      }
                    >
                      <span className="skilledition-faq-question">
                        {faq.question}
                      </span>

                      <span className="skilledition-faq-icon">
                        {activeKey === index.toString() ? (
                          <FiMinus />
                        ) : (
                          <FiPlus />
                        )}
                      </span>
                    </Accordion.Header>

                    <Accordion.Body className="skilledition-faq-answer">
                      {faq.answer}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="skilledition-banner-section reveal">
        <Container>
          <div className="skilledition-banner-section-wrapper">
            <div className="skilledition-banner-section-left">
              <h2 className="skilledition-banner-section-title">
                Ready to Start Your <br />
                Internship Journey?
              </h2>

              <p className="skilledition-banner-section-text">
                Master in-demand skills, build real-world projects, and
                kickstart your career with internship opportunities.
              </p>

              <div className="skilledition-banner-btn-wrapperss">
                {/* <Button
                                    className="skilledition-banner-section-btnss"
                                    onClick={() => navigate("/course")}
                                >

                                </Button> */}
                <Button
                  className="skilledition-banner-section-btn"
                  onClick={() => navigate("/courses")}
                >
                  Explore Courses <IoArrowForwardOutline />
                </Button>
                <Button
                  className="skilledition-banner-section-btn-supportss"
                  onClick={openWhatsApp}
                >
                  Talk to Support <IoArrowForwardOutline />
                </Button>
              </div>
            </div>

            <div className="skilledition-banner-section-right">
              <img
                src={HomeBanner}
                alt="Dashboard Preview"
                className="skilledition-banner-section-image"
              />
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Internshipprogramme;
